module.exports = __webpack_public_path__ + "img/Weapon_133.aff69144.png";